<template>
  <div v-if="mediaQueries.tab" class="jackpot__games">
    <div v-for="(game, key) in gamesArray.games" :key="key" class="jackpot__games-game">
      <logo-game :key="game.id" :item="game" :need-footer="false" />
    </div>
    <div v-if="gamesArray.count > 0" class="jackpot__games-game jackpot__games-game--all" @click="$emit('click')">
      <div class="jackpot__games-game-label">{{ t('allGames') }}</div>
      <div class="jackpot__games-game-count">{{ gamesArray.count }}</div>
    </div>
  </div>
  <div v-else class="jackpot__games">
    <swiper
      v-if="games"
      v-bind="swiperOptions"
      :modules="[Grid, FreeMode]"
      class="swiper-jackpot-games"
      @swiper="onSwiper"
    >
      <swiper-slide v-for="game in games" :key="game">
        <div class="jackpot__games-game">
          <logo-game :key="game.id" :item="game" :need-footer="false" />
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script setup>
import { FreeMode, Grid } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

import { computed, inject, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import LogoGame from 'components/games/LogoGame.vue'

const props = defineProps({
  games: {
    type: Array,
    default: () => [],
  },
})
defineEmits(['click'])
const { t } = useI18n()
const mediaQueries = inject('mediaQueries')
const swiperOptions = {
  threshold: 10,
  slidesPerView: 3.1,
  slidesPerGroup: 3,
  spaceBetween: 8,
  breakpoints: {
    768: {
      slidesPerView: 5,
      slidesPerGroup: 5,
    },
    1024: {
      slidesPerView: 7,
      slidesPerGroup: 7,
    },
  },
}

const swiperInstance = ref(null)
const gamesArray = computed(() => {
  if (mediaQueries.tab && !mediaQueries.desktop) {
    return {
      games: props.games.slice(0, 4),
      count: props.games.length - 4 > 0 ? props.games.length - 4 : 0,
    }
  } else if (mediaQueries.desktop && !mediaQueries.desktopMedium) {
    return {
      games: props.games.slice(0, 3),
      count: props.games.length - 3 > 0 ? props.games.length - 3 : 0,
    }
  } else if (mediaQueries.desktopMedium && !mediaQueries.desktopBig) {
    return {
      games: props.games.slice(0, 4),
      count: props.games.length - 4 > 0 ? props.games.length - 4 : 0,
    }
  } else if (mediaQueries.desktopBig) {
    return {
      games: props.games.slice(0, 5),
      count: props.games.length - 5 > 0 ? props.games.length - 5 : 0,
    }
  } else {
    return props.games
  }
})

function onSwiper(swiper) {
  swiperInstance.value = swiper
}
</script>

<style lang="scss" scoped>
.swiper-jackpot-games {
  @include mobile {
    overflow: visible;
  }
}

.jackpot__games {
  margin-top: 24px;
  width: 100vw;
  overflow-x: hidden;
  padding-left: 12px;
  margin-left: -12px;
  @include tab {
    display: flex;
    width: 100%;
    padding-left: 0;
    margin-left: 0;
    gap: 8px;
  }
  @include desktop {
    margin-top: 24px;
  }

  &-game {
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.07);
    backdrop-filter: blur(4px);
    overflow: hidden;

    @include tab {
      width: calc(100% / 5 - 8px);
      cursor: pointer;
    }
    @include desktop {
      width: calc(100% / 4 - 8px);
      cursor: pointer;
    }
    @include desktop-xxl {
      width: calc(100% / 6 - 8px);
      cursor: pointer;
    }

    &--all {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: rgba(255, 255, 255, 0.9);
      font-size: 16px;
      font-weight: 500;
      gap: 8px;
      text-align: center;
      line-height: 16px;
      @include desktop {
        font-size: 14px;
        gap: 4px;
      }
      @include desktop-xxl {
        font-size: 16px;
        gap: 8px;
      }
    }

    &-count {
      font-size: 12px;
      width: fit-content;
      border-radius: 16px;
      background: rgba(255, 255, 255, 0.07);
      padding: 4px 8px;
      line-height: 14px;
    }
  }
}
</style>
